module.exports = __webpack_public_path__ + "files/4a7d2d8545dc2b1720a0e5dbbecc378a.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects.png
// module id = 589
// module chunks = 59